import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  Row,
  Container,
  Table,
} from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import magic1 from "../Images/keyw1.png";
import magic2 from "../Images/keyw2.png";
import key1 from "../Images/key1.svg";
import key2 from "../Images/key2.svg";
import key3 from "../Images/key3.svg";
import key4 from "../Images/key4.svg";
import key5 from "../Images/key5.svg";
import key6 from "../Images/cardimg5.svg";
import core1 from "../Images/core1.png";
import core2 from "../Images/core2.png";
import core3 from "../Images/core3.png";
import core4 from "../Images/core4.png";
import core5 from "../Images/core5.png";
import core6 from "../Images/core6.png";
import pay from "../Images/pay.png";
import SideTab from "./Toolstab";
import { FaArrowRight, FaChartLine, FaGlobe, FaSearch } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import Testimonials from "./Testonomial";
import { basicauth } from "../Utils/Credentials";
const Positiontracker = () => {



  return (
    <div>
      <Nav />
      <Container fluid className="p-0 mt-5" style={{ overflow: "clip" }}>
        <Keywordpositiontool />
        <Row className="justify-content-center" style={{ margin: "0" }}>
          <Col md={10}>
            <Row className="justify-content-between">
              <Col md={8}>
                <Content />
              </Col>

              <Col md={3}>
                <div
                  className="mb-5"
                  style={{
                    position: "sticky",
                    top: "100px",
                    zIndex: 10,
                    background: "#f8f9fa",
                    padding: "1rem",
                    borderRadius: "10px",
                  }}
                >
                  <h5
                    className="text-center mb-4"
                    style={{
                      fontWeight: "bold",
                      fontSize: "1.3rem",
                      color: "#fff",
                      backgroundColor: "#799EFF",
                      display: "inline-block",
                      padding: "6px 16px",
                      borderRadius: "0.5rem",
                    }}
                  >
                    🚀 Explore More SEO Tools
                  </h5>
                  <SideTab />
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background:
            "linear-gradient(to right, rgb(175, 221, 255), rgb(255, 255, 255))",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </div>
  );
};
const Content = () => {
  const [showMore, setShowMore] = useState(false);

  return (
    <>
      <p className="mt-5">
        Keyword research is all about finding the keywords or phrases that
        people enter in search engines. It tells you what consumers want, the
        language they use and how stiff the competition is for each keyword.
        Blog, e-commerce web or a service-based business keyword research will
        always guarantee that your content follows actual search demands and not
        just guessed factors that would produce results.
      </p>

      <h2>Why Do You Need The Best Keyword Research Tool?</h2>
      <p>
        <strong>Uncover high-potential keywords</strong>
        <br />
        With the best keyword research tool at your disposal, you move away from
        the obvious high competition keywords and instead search for long-tail
        phrases with value that are actually searched for by the audience. These
        niche terms mostly bring highly targeted traffic, making conversion
        easier as they represent very refined intent. By focusing your content
        around these terms, your site becomes more relevant to your target
        market. This smart approach to keyword research can help small
        businesses and growing brands compete with bigger players.
      </p>
      <div style={{ position: "relative" }}>
        <p
          style={{
            maxHeight: showMore ? "none" : "4.2rem",
            overflow: "hidden",
            textOverflow: "ellipsis",
            WebkitLineClamp: 2,
            display: "-webkit-box",
            WebkitBoxOrient: "vertical",
            filter: showMore ? "none" : "blur(2px)",
            transition: "all 0.3s ease",
            marginBottom: showMore ? "1rem" : "2.5rem",
          }}
        >
          <strong>Understand competition</strong>
          <br />
          Good keyword research tools do not just show what people are searching
          for, but they also give insight into how difficult it might be to rank
          for those keywords. In becoming aware of keyword competitiveness, you
          can choose terms that give your site the best chance to show on the
          first page. From this perspective, your SEO strategy is based on data
          rather than on mere assumptions. Even a free keyword research tool
          typically offers a very basic difficulty score with which to guide
          your decision.
        </p>

        {!showMore && (
          <div
            style={{
              position: "absolute",
              bottom: "0.5rem",
              left: 0,
              right: 0,
              height: "2.5em",
              background:
                "linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)",
            }}
          />
        )}
      </div>

      <div className="d-flex justify-content-center">
        {!showMore && (
          <Button
            onClick={() => setShowMore(true)}
            style={{
              padding: "6px 20px",
              backgroundColor: "#fff",
              color: "#0d6efd",
              fontWeight: "600",
              fontSize: "0.95rem",
              border: "2px solid #0d6efd",
              borderRadius: "999px",
              boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
              transition: "all 0.3s ease",
            }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = "#0d6efd";
              e.target.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = "#fff";
              e.target.style.color = "#0d6efd";
            }}
          >
            Read More
          </Button>
        )}
      </div>

      {showMore && (
        <>
          <p>
            <strong>Content Planning</strong>
            <br />
            Proper keyword research is not merely about finding the words it
            also forms a whole content strategy. By finding groups of related
            SEO search keywords, you can plan blog posts, service pages and
            landing pages based on what people actually want. The right SEO
            keyword research tool will help you identify gaps in your existing
            content and new subject matter relevant to your audience. This sort
            of structured planning will result in increased traffic and
            engagement down the line.
          </p>
          <p>
            <strong>Tracking SEO performance</strong>
            <br />
            Apart from the initial research, the best keyword analysis tool lets
            you keep an eye on your rankings for chosen keywords over weeks and
            months. This transparency of ongoing monitoring reveals which
            strategies are working and which need adjustment, giving you clear
            ROI data on your SEO efforts. Even if you start with a free keyword
            research tool, consistent tracking can highlight trends and keep
            your content competitive in search results.
          </p>

          <h2>Free Keyword Research Tools You Can Try</h2>
          <p>
            While premium tools often offer deeper insights, some free keyword
            research tools can still help you kickstart your SEO journey:
          </p>
          <div className="d-flex justify-content-center">
            <img
              className="mb-3"
              src={magic1}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>
          <h3>SeoBix</h3>
          <p>
            SeoBix employs different keyword tools ranging from premium to free
            for creating carefully crafted and data-oriented strategies for your
            brand. Instead of utilizing only one free keyword research tool, our
            team finds the best keyword tool that can cater to specific needs of
            the client to reveal promising keywords, competition, and track
            overtime. Working with SeoBix means that keyword research is more
            than merely a step to get through; it is what paves the way toward a
            clever SEO plan, which actually produces results.
          </p>

          <h3>Google Keyword Planner</h3>
          <p>
            Google Keyword Planner is a free classic keyword research tool that
            pulls data from Google directly, making it apt to input exact search
            keywords and estimate search volume. It mainly benefits start-ups by
            showing how keyword trends fluctuate over time and by showing
            related keywords the user may not have thought about.
          </p>

          <h3>AnswerThePublic</h3>
          <p>
            AnswerThePublic takes keyword research a step further by revealing
            the real questions and long-tail phrases your potential customers
            type into search engines. As a keyword analysis free tool, it
            visualizes data beautifully, showing keyword variations around
            topics your brand cares about. This makes it easier to create
            content that directly answers audience questions.
          </p>

          <h3>Ubersuggest</h3>
          <p>
            Ubersuggest offers a generous free keyword research tool plan that
            delivers keyword suggestions, search volume, seasonal trends and
            competitiveness all in one place. It’s user-friendly and ideal for
            anyone starting to explore seo keyword research tools. For
            businesses working with limited budgets, Ubersuggest helps
            prioritize keywords that matter most.
          </p>

          <h2 className="mt-2 mb-3">
            Bix keyword Research Giving You Extra Points:
          </h2>
          <div className="d-flex justify-content-center">
            <img
              className="mb-3"
              src={magic2}
              alt="seobix"
              style={{ width: "50vw" }}
            />
          </div>

          <h2>Frequently Asked Questions (FAQ)</h2>

          <Accordion defaultActiveKey="0" className="mb-5" flush>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                What is keyword research and why is it important?
              </Accordion.Header>
              <Accordion.Body>
                Keyword research is the process through which the words and
                phrases that the intended clients use for online searches are
                determined. It gives importance to understanding what potential
                clients are seeking so they can put the right content before
                them with higher search engine rankings. If you miss out on
                conducting keyword research properly, you may miss hitting the
                SEO target with your audience.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1">
              <Accordion.Header>
                Are there any free keyword research tools I can use?
              </Accordion.Header>
              <Accordion.Body>
                Yes. There are various keyword research and keyword analysis
                free tools useful for beginners and small businesses. Popular
                choices would be Seobix, Google Keyword Planner, Ubersuggest
                (free version), AnswerThePublic and Keyword Surfer. Although
                these free tools may not be deep-dive into the data, they still
                have some insights for you.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2">
              <Accordion.Header>
                What is a keyword analysis tool?
              </Accordion.Header>
              <Accordion.Body>
                More than finding the keywords, a tool analyzes their potential
                by calculating the search volume, difficulty of the keywords,
                trends and competitiveness. By using the best keyword analysis
                tool, you can be assured that the keywords you select will bring
                in real traffic for your business and will be aligned with the
                objectives of your business.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3">
              <Accordion.Header>
                Can keyword analysis tools help with local SEO?
              </Accordion.Header>
              <Accordion.Body>
                Absolutely. Many tools for SEO keyword research give you an
                option to sort keywords by location so you can find SEO search
                keywords most relevant to a specific local audience. This is
                especially beneficial for businesses that are trying to pair
                with near me and geo specific searches.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4">
              <Accordion.Header>
                Why use Our Bix keyword Research ?
              </Accordion.Header>
              <Accordion.Body>
                <p> Unlock millions of keyword opportunities in SeoBix Tool</p>
                <p>
                  <b> Everyone Can Do SEO: </b> Keyword research should not be
                  complicated or overwhelming. This keyword tool simply makes it
                  easy to use by students through an integrated interface around
                  which even a rookie would be able to get their heads around.
                  Filter keywords for search volume, CPC, competition,
                  difficulty, and more. so far in his effort to save time and
                  take a deeper dive into his findings, whether on his laptop or
                  tablet, because using the tool feels natural and easy with
                  navigation.
                </p>
                <p>
                  <b> Better Organized, Faster Ranked: </b> There are now no
                  more headaches regarding organizing your keywords manually.
                  Our tool will automatically group relevant keywords into their
                  intelligent clusters by topics, so planning blog posts, ad
                  campaigns, and SEO pages is simplified. You'll immediately see
                  which keywords are going together and create faster,
                  topic-focused strategies. It's the secret sauce behind
                  creating a strong site structure with better ranking
                  opportunities. In addition, it saves hours on end.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          <div className="d-flex justify-content-center mt-4">
            <Button
              onClick={() => setShowMore(false)}
              style={{
                padding: "6px 20px",
                backgroundColor: "#fff",
                color: "#dc3545",
                fontWeight: "600",
                fontSize: "0.95rem",
                border: "2px solid #dc3545",
                borderRadius: "999px",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                transition: "all 0.3s ease",
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = "#dc3545";
                e.target.style.color = "#fff";
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = "#fff";
                e.target.style.color = "#dc3545";
              }}
            >
              Hide
            </Button>
          </div>
        </>
      )}
      <Plancard />
      <Trialcards />
      <Related />
      <Testimonials />
      <Specialoffer />
      <BackLinkCards />
      <Plancard />
    </>
  );
};
const Plancard = () => {
  const [isYearly, setIsYearly] = useState(false);
  const plans = [
    {
      title: "Free",
      monthly: "$0",
      yearly: "$0",
      Free: "3 Month Free Trial",
      features: ["Limited Access"],
      buttonText: "Buy Plan",
      color: "#e0f2fe",
      border: "#38bdf8",
      image: pay,
    },
    {
      title: "Basic",
      monthly: "$150/mo",
      features: ["5 Projects", "Standard Reports", "Email Support"],
      buttonText: "Buy Plan",
      color: "#e7f5ff",
      border: "#339af0",
      image: pay,
    },
    {
      title: "Standard",
      monthly: "$350/mo",
      features: ["10 Projects", "Advanced Reports", "Priority Support"],
      buttonText: "Buy Plan",
      color: "#e6fcf5",
      border: "#20c997",
      image: pay,
    },
    {
      title: "Premium",
      monthly: "$750/mo",
      features: ["Unlimited Projects", "All Features", "24/7 Support"],
      buttonText: "Buy Plan",
      color: "#fff3bf",
      border: "#fcc419",
      image: pay,
    },
  ];

  return (
    <Container className="my-5">
      <div className="text-center mb-4">
        <h2 style={{ fontWeight: "700", fontSize: "2rem" }}>
          Boost Your SEO With Our Amazing Plans
        </h2>
        <h4 className="font-weight-bold mb-4" style={{ color: "#441752" }}>
          🚀 Improve Your Rankings —{" "}
          <span style={{ color: "#FC4100" }}>Try Our Service Free for 3 Months!</span>
        </h4>
        <p style={{ color: "#6b7280" }}>
          Flexible pricing plans designed for every stage of your journey
        </p>
        <div className="d-flex justify-content-center mt-4">
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontWeight: "500" }}>Monthly</span>

            <div
              className="m-2"
              style={{ transform: "scale(1.5)", transformOrigin: "center" }}
            >
              <Form.Check
                type="switch"
                id="custom-switch"
                checked={isYearly}
                onChange={() => setIsYearly(!isYearly)}
              />
            </div>

            <div className="d-flex align-items-center gap-2">
              <span style={{ fontWeight: "500" }}>Yearly</span>

              <div
                className="start-now-btn mx-3"
                style={{
                  backgroundColor: "#e6f4ea",
                  color: "#2f855a",
                  padding: "6px 12px",
                  borderRadius: "8px solid",
                  fontWeight: "600",
                  fontSize: "0.9rem",
                  border: "1px solid #20c997",
                }}
              >
                🎉{" "}
                <span style={{ color: "#0B1D51" }}>
                  Get{" "}
                  <span style={{ color: "#0B1D51" }}>
                    <b>30% OFF</b>
                  </span>{" "}
                  on Yearly Plans
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Row className="g-4 justify-content-center">
        {plans.map((plan, idx) => (
          <Col md={6} lg={3} key={idx}>
            <div style={{ position: "relative" }}>
              {plan.title === "Free" && (
                <div
                  style={{
                    position: "absolute",
                    top: "-12px",
                    left: 0,
                    right: 0,
                    height: "32px",
                    backgroundColor: "#38bdf8",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontWeight: "700",
                    fontSize: "1rem",
                    borderTopLeftRadius: "16px",
                    borderTopRightRadius: "16px",
                    zIndex: 2,
                  }}
                >
                  {plan.Free}
                </div>
              )}

              <Card
                className="p-2"
                style={{
                  backgroundColor: plan.color,
                  border: `2px solid ${plan.border}`,
                  borderRadius: "16px",
                  textAlign: "center",
                  height: "100%",
                  boxShadow:
                    plan.title === "Free"
                      ? "0 12px 28px rgba(56, 189, 248, 0.5)"
                      : "0 4px 12px rgba(0,0,0,0.05)",
                  marginTop: plan.title === "Free" ? "16px" : "0",
                }}
              >
                <Card.Body>
                  <Card.Title style={{ fontSize: "1.5rem", fontWeight: "700" }}>
                    {plan.title}
                  </Card.Title>
                  <h3 style={{ fontWeight: "bold", margin: "1rem 0" }}>
                    {isYearly
                      ? plan.title === "Free"
                        ? plan.yearly
                        : (() => {
                            const monthlyPrice = parseFloat(
                              plan.monthly.replace(/[^0-9.]/g, "")
                            );
                            const yearlyRaw = monthlyPrice * 12;
                            const discounted = yearlyRaw * 0.7;
                            return `$${Math.round(discounted)}/yr`;
                          })()
                      : plan.monthly}
                  </h3>
                  <a
                    href="/register"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "inline-block",
                      backgroundColor: plan.border,
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "999px",
                      padding: "8px 20px",
                      fontWeight: "600",
                      marginTop: "1rem",
                    }}
                  >
                    {plan.buttonText}
                  </a>

                  <div className="mt-3">
                    <img
                      src={plan.image}
                      alt={plan.title}
                      style={{
                        // width: "15vw",
                        objectFit: "contain",
                        marginBottom: "1rem",
                      }}
                    />
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};
const Trialcards = () => {
  const cardsData = [
    {
      keyImg: key1,
      coreImg: core5,
      title: "Integrated Search Console, Google Trends and Google Analytics",
      desc: "Smarter SEO insights in one place and see what’s popular in different countries and other website matrics. Seobix makes it easy and effective.",
    },
    {
      keyImg: key2,
      coreImg: core4,
      title: "Search Engine Optimization",
      desc: "SEO gets easier with SeoBix whether you just start your website or growing your online presence. Our all-in-one SEO tool helps you fix issues and improve online visibility.",
    },
    {
      keyImg: key3,
      coreImg: core2,
      title: "Social Media Optimization",
      desc: "You can monitor and post from all your favorite platforms, YouTube, Facebook, LinkedIn, and Instagram, all from under one roof.",
    },
    {
      keyImg: key4,
      coreImg: core1,
      title: "Competitive Research Overview",
      desc: "You can check domain overview and website age and how their pages look on Google with our SERP Simulator. Seobix gives you the insights you need to compete smarter, not harder.",
    },
    {
      keyImg: key5,
      coreImg: core3,
      title: "Structure Data",
      desc: "With the right setup, At Seobix, we make it super easy to add and check structured data, so your site gets noticed for all the right reasons.",
    },
    {
      keyImg: key6,
      coreImg: core6,
      title: "Keyword Research",
      desc: "Our Bix keyword Research helps you discover high-potential keywords your audience is actually searching for.",
    },
  ];
  return (
    <div className="mt-md-5 mt-3 m-md-0 m-2 ">
      <h2
        className="text-center m-4"
        style={{ fontWeight: "700", fontSize: "2rem" }}
      >
        What Includes In All Plans ?
      </h2>
      <div className="row m-0 p-0">
        {cardsData.map((card, index) => (
          <div key={index} className="col-12 col-md-4 p-2 d-flex">
            <div className="card w-100 h-100 p-2">
              <div className="d-flex h-100">
                <div
                  style={{ flex: 1 }}
                  className="d-flex flex-column position-relative"
                >
                  <div>
                    <img
                      src={card.keyImg}
                      alt={card.title}
                      style={{
                        height: "5vh",
                        objectFit: "contain",
                        marginBottom: "0.5rem",
                      }}
                    />
                    <h5>{card.title}</h5>
                  </div>
                </div>

                <div
                  style={{ flex: 1 }}
                  className="d-flex align-items-center justify-content-center"
                >
                  <img
                    src={card.coreImg}
                    alt={card.title}
                    className="img-fluid"
                    style={{ maxHeight: "200px", objectFit: "contain" }}
                  />
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
const Specialoffer = () => {
  return (
    <div
      className="start-now-btn p-2"
      style={{
        background: "#799EFF",
        borderRadius: "24px",
        color: "white",
        textAlign: "center",
        margin: "3rem auto",
        width: "90%",
        maxWidth: "1000px",
        position: "relative",
      }}
    >
      <h2 className="mb-3" style={{ fontSize: "2rem", fontWeight: "bold" }}>
        Let’s do this! Start unlocking powerful backlink insights.
      </h2>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "16px",
          flexWrap: "wrap",
        }}
      >
        <a
          // href="/register"
          onClick={() =>
            window.open("https://dashboard.seobix.com/", "_blank")
          }
          style={{
            backgroundColor: "#fff",
            color: "#000",
            padding: "12px 24px",
            borderRadius: "12px",
            fontWeight: "600",
            textDecoration: "none",
            minWidth: "150px",
            textAlign: "center",
          }}
        >
          Start 3 Months Free Trial
        </a>
      </div>

      <p style={{ color: "#fff", marginTop: "20px", fontSize: "14px" }}>
        <b> Full access — No Credit card Needed.</b>
      </p>
    </div>
  );
};
const Related = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [selfDomain, setSelfDomain] = useState("");
  const [competitorDomain, setCompetitorDomain] = useState("");
  const [selectedDomainType, setSelectedDomainType] = useState({
    value: "root",
    label: "Root Domain",
  });
  const [expandedRow, setExpandedRow] = useState(null);
  const [apiData, setApiData] = useState([]);
  const { password, username } = basicauth;
  const base64Credentials = btoa(`${username}:${password}`);


  const generateUUID = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const handleSubmit = async () => {
    const uuid = generateUUID();
    const session = generateUUID();
    const urls = [selfDomain, competitorDomain].filter(Boolean);
    setLoading(true);
    const scope = selectedDomainType.value === "root" ? "domain" : "subdomain";
    const requestData = {
      uuid,
      urls,
      scope,
      session,
    };
    console.log("Request Data:", requestData);
    try {
      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/CompetitiveResearch/FetchBulkSiteMetrics`,
        {
          method: "POST",
         headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        }
      );

      const data = await response.json();
      if (data.status === "0") {
        setApiData(data.data);
        setLoading(false);
      } else {
        console.error("Error fetching data:", data.msg);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setLoading(false);
    }
  };


  const handleClick = () => {
    navigate(
      "/keyword-gap"
    );
  };

  return (
    <div className="mt-5 mb-5">
      <div
        // onClick={handleClick}
        style={{
          cursor: "pointer",
        }}
      >
        <Row
          className="justify-content-center"
          style={{
            margin: "0",
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
            borderRadius: "12px",
            transition: "transform 0.2s ease",
          }}
          onMouseEnter={(e) =>
            (e.currentTarget.style.transform = "scale(1.01)")
          }
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <Col md={10} className="p-3">
            <h3 className="text-center">
              <b>Find Keyword Gaps vs Your Competitors</b>
            </h3>
            <p className="text-center">
              Discover which keywords your competitors rank for — but you don’t.
              Uncover missed SEO opportunities and boost your content strategy.
            </p>

            <Form className="mb-2">
              <Row className="align-items-center gx-2">
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter your domain"
                      value={selfDomain}
                      onChange={(e) => setSelfDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Form.Group className="mb-0">
                    <Form.Control
                      type="text"
                      placeholder="Enter competitor domain"
                      value={competitorDomain}
                      onChange={(e) => setCompetitorDomain(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col md={4}>
                  <Row className="g-2 align-items-center">
                    <Col xs={9}>
                      <Form.Group className="mb-0">
                        <Form.Select
                          value={selectedDomainType}
                          onChange={(e) =>
                            setSelectedDomainType(e.target.value)
                          }
                          aria-label="Select Domain Type"
                          style={{
                            borderRadius: "6px",
                            padding: "0.5rem",
                            fontWeight: "500",
                            color: "#333",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                          }}
                        >
                          <option value="">Select Domain Type</option>
                          <option value="root">Root Domain</option>
                          <option value="sub">Sub Domain</option>
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xs={3}>
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={handleSubmit}
                        style={{ whiteSpace: "nowrap", width: "100%" }}
                      >
                        Submit
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
            <div className=" mt-4">
              {apiData.length > 0 && (
                <Table responsive>
                  <colgroup>
                    <col style={{ width: "25%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                    <col style={{ width: "20%" }} />
                  </colgroup>

                  <thead>
                    <tr>
                      <th className="text-center">Domain</th>
                      <th className="px-3">Domain Authority</th>
                      <th className="px-3">Page Authority</th>
                      <th className="px-3">Spam Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiData.map((item, index) => (
                      <React.Fragment key={item.id}>
                        <tr>
                          <td className="text-center">{item.url}</td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.da}
                              stroke="#799EFF"
                              label={`${item.da}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut
                              value={item.pa}
                              stroke="#FFA500"
                              label={`${item.pa}`}
                            />
                          </td>

                          <td
                            className="p-2"
                            style={{ width: "100px", textAlign: "center" }}
                          >
                            <CustomDoughnut value={item.spam_score} />
                          </td>
                        </tr>
                      </React.Fragment>
                    ))}
                  </tbody>
                </Table>
              )}
            </div>
            <h6 className="text-end m-4" onClick={handleClick}>
              Click to get more details <FaArrowRight />
            </h6>
          </Col>
        </Row>
      </div>
    </div>
  );
};
const CustomDoughnut = ({ value, size = 64 }) => {
  const strokeWidth = 10;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = ((100 - value) / 100) * circumference;

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        position: "relative",
      }}
    >
      <svg width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#e0e0e0"
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke="#799EFF"
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={progress}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#0A3981",
        }}
      >
        {value}%
      </div>
    </div>
  );
};
const cardData = [
  {
    title: "Keyword Gap Analyzer",
    description:
      "Discover keyword opportunities by comparing your website with top competitors. Uncover missing keywords and content gaps.",
    linkText: "Keyword Gap Tool",
    linkUrl:
      "/keyword-gap",
    bgColor: "#f4f7fb",
  },
  {
    title: "Ranking Keywords by Domain",
    description:
      "Find out which keywords each domain ranks for, and analyze traffic-driving terms for any site in your niche.",
    linkText: "Ranking Keyword Tool",
    linkUrl: "/bix-keyword-analyzer",
    bgColor: "#dff5ff",
  },
  {
    title: "Keyword Position Tracker",
    description:
      "Track daily keyword rankings for your target terms. Monitor SERP positions, gains, and drops across devices and locations.",
    linkText: "Position Tracker",
    linkUrl: "/keyword-position-tracker",
    bgColor: "#f4f7fb",
  },
  {
    title: "Keyword Builder",
    description:
      "Generate powerful keyword combinations to boost your SEO strategy. Build long-tail and intent-based keyword lists in seconds.",
    linkText: "Keyword Builder",
    linkUrl: "/construct-your-seo-success-with-keyword-builder",
    bgColor: "#d6ffd6",
  },
];
const Keywordpositiontool = () => {
  const regionOptions = [
    { value: "en-US", label: "United States (en-US)" },
    { value: "en-GB", label: "United Kingdom (en-GB)" },
    { value: "en-CA", label: "Canada (English) (en-CA)" },
    { value: "en-AU", label: "Australia (en-AU)" },
  ];
  const [formData, setFormData] = useState({
    Keyword: "",
    region: regionOptions[0],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div className="mb-4">
      {/* HERO SECTION */}
      <div
        style={{
          background: "linear-gradient(to right, #AFDDFF, #EDF8FF, #FFFFFF)",
          paddingBottom: "3rem",
          boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
        }}
      >
        <Row className="justify-content-center">
          <Col md={10}>
            <h1 className="p-3 text-center" style={{ color: "rgb(9, 0, 64)" }}>
              <FaChartLine style={{ marginRight: "10px" }} />
              Track Your Keyword Rankings with Precision
            </h1>
            <p
              className="text-center"
              style={{
                fontSize: "1rem",
                color: "rgb(9, 0, 64)",
                maxWidth: "700px",
                margin: "0 auto",
              }}
            >
              Monitor how your keywords perform across Google regions and
              devices. Get real-time insights to optimize your SEO strategy and
              outperform competitors.
            </p>

            {/* INPUT FORM */}
            <Row className="p-4 mt-3 align-items-center">
              <Col md={8} className="p-0">
                <Form.Control
                  type="text"
                  placeholder="🔍 Enter a Keyword"
                  value={formData.Keyword}
                  onChange={(e) => handleChange("Keyword", e.target.value)}
                  required
                  style={{
                    color: "#090040",
                    borderRadius: "0.25rem",
                    fontSize: "1.2rem",
                    height: "48px",
                    border: "1px solid #ccc",
                    marginRight: "8px",
                  }}
                />
              </Col>

              <Col md={2} className="p-0">
                <select
                  className="form-select"
                  value={formData.region?.value || ""}
                  onChange={(e) =>
                    handleChange("region", {
                      value: e.target.value,
                      label:
                        regionOptions.find(
                          (opt) => opt.value === e.target.value
                        )?.label || "",
                    })
                  }
                  style={{
                    height: "48px",
                    borderRadius: "0.25rem",
                    border: "1px solid #ccc",
                    fontSize: "0.9rem",
                    fontWeight: "500",
                    color: "#090040",
                    padding: "0 10px",
                    marginRight: "8px",
                  }}
                >
                  <option value="">🌍 Region</option>
                  {regionOptions.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </Col>

              <Col md={2} className="p-0">
                <Button
                  style={{
                    background: "#FF8000",
                    color: "#fff",
                    border: "none",
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    height: "48px",
                    width: "100%",
                    borderRadius: "0.25rem",
                  }}
                >
                  Analyze
                </Button>
              </Col>
            </Row>

            {/* FEATURE CARDS */}
            <Row className="mt-5 text-center">
              <Col md={4}>
                <Card style={{ border: "none", background: "#f5faff" }}>
                  <Card.Body>
                    <FaGlobe size={30} style={{ color: "#007BFF" }} />
                    <h5 className="mt-3">Geo-based Tracking</h5>
                    <p style={{ fontSize: "0.9rem" }}>
                      Track keyword ranks across multiple countries or regions.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={4}>
                <Card style={{ border: "none", background: "#f5faff" }}>
                  <Card.Body>
                    <FaSearch size={30} style={{ color: "#28a745" }} />
                    <h5 className="mt-3">Keyword Insights</h5>
                    <p style={{ fontSize: "0.9rem" }}>
                      Get accurate position reports and historical trend charts.
                    </p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={4}>
                <Card style={{ border: "none", background: "#f5faff" }}>
                  <Card.Body>
                    <FaChartLine size={30} style={{ color: "#ff6600" }} />
                    <h5 className="mt-3">SEO Progress</h5>
                    <p style={{ fontSize: "0.9rem" }}>
                      Visualize improvements in keyword rankings over time.
                    </p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};
const BackLinkCards = () => {
  return (
    <div style={{ overflow: "hidden", padding: "20px" }}>
      <div className="container">
        <div className="text-center mb-5">
          <h2 className="fw-bold">
            All-in-One Keyword Intelligence Suite: Discover, Track, and Optimize
            Every Opportunity
          </h2>
        </div>
        <div className="row justify-content-center g-4">
          {cardData.map((card, index) => (
            <div key={index} className="col-md-6 col-lg-3 p-1">
              <div
                style={{
                  backgroundColor: card.bgColor,
                  padding: "24px",
                  borderRadius: "20px",
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <h5 className="fw-bold">{card.title}</h5>
                  <p className="text-muted" style={{ fontSize: "15px" }}>
                    {card.description}
                  </p>
                </div>
                <div>
                  <a
                    href={card.linkUrl}
                    className="text-primary fw-semibold"
                    style={{ textDecoration: "none" }}
                  >
                    {card.linkText} →
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Positiontracker;
